import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCalendarAlt, faTag } from '@fortawesome/free-solid-svg-icons';
import { getAnnouncementBySlug, announcements } from '../../data/announcements';
import ImageGallery from '../../components/ImageGallery';
import duyurularHeroImage from '../../assets/images/duyurular.jpg';
import '../AnnouncementPages/AnnouncementDetail.css';

const AnnouncementDetailEN = () => {
  const { slug } = useParams();
  const announcement = getAnnouncementBySlug(slug);

  // Translate announcement content
  const translateAnnouncement = (announcement) => {
    if (!announcement) return null;
    
    const translations = {
      'etkim-bakan-ziyareti': {
        title: 'Minister of National Education Prof. Dr. Yusuf Tekin\'s ETKİM Visit',
        excerpt: 'With the attendance of our Minister of National Education, Prof. Dr. Yusuf Tekin, the "Educational Technologies Ecosystem Meeting" was held hosted by ETKİM.',
        category: 'Event',
        content: `📢 With the attendance of <strong>our Minister of National Education, Prof. Dr. Yusuf Tekin</strong>, the "Educational Technologies Ecosystem Meeting" was held hosted by ETKİM.

During the event, we had the opportunity to share with our Minister ProgenX's work, our innovative approach to educational technologies, and the potential contributions we can offer to our country's education system.

A comprehensive evaluation was made about the AI-powered solutions we have developed as ProgenX, our digital learning ecosystem, and our student-teacher-focused vision.

We thank <strong>our Minister Prof. Dr. Yusuf Tekin</strong> for his visit and valuable insights.

As ProgenX, we will continue our work with the goal of contributing to our country's educational vision.`
      },
      'bett-uk-ziyaret': {
        title: 'Deputy Minister and Director General Visit at BETT UK',
        excerpt: 'At BETT UK, Deputy Minister of the Ministry of National Education, Mr. M. Bilal Macit, and Director General of Innovation and Educational Technologies, Mr. Mustafa Canlı, visited the ProgenX stand.',
        category: 'Event',
        content: `📢 At BETT UK, <strong>Deputy Minister of the Ministry of National Education, Mr. M. Bilal Macit</strong> and <strong>Director General of Innovation and Educational Technologies, Mr. Mustafa Canlı</strong>, visited the ProgenX stand.

During the visit, we had the opportunity to evaluate:
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Our innovative approach to educational technologies,</li>
  <li style="margin-bottom: 10px;">• Our AI-powered solutions and products,</li>
  <li style="margin-bottom: 10px;">• The potential contributions we can offer to education in Türkiye,</li>
  <li style="margin-bottom: 10px;">• Possible collaborations that can be carried out with the Ministry of National Education,</li>
  <li style="margin-bottom: 10px;">• Our digital learning ecosystem developed for students, teachers, and institutions.</li>
</ul>

As ProgenX, we continue to work to contribute to our country's educational vision and to shape the learning experience of the future.

We extend our sincere thanks to <strong>Mr. M. Bilal Macit</strong> and <strong>Mr. Mustafa Canlı</strong> for their visit and valuable insights.`
      },
      'bett-uk-bakan-yardimcisi-ziyareti': {
        title: 'Deputy Minister and Director General Visit at BETT UK',
        excerpt: 'At BETT UK, Deputy Minister of the Ministry of National Education, Mr. M. Bilal Macit, and Director General of Innovation and Educational Technologies, Mr. Mustafa Canlı, visited the ProgenX stand.',
        category: 'Event',
        content: `📢 At BETT UK, <strong>Deputy Minister of the Ministry of National Education, Mr. M. Bilal Macit</strong> and <strong>Director General of Innovation and Educational Technologies, Mr. Mustafa Canlı</strong>, visited the ProgenX stand.

During the visit, we had the opportunity to evaluate:
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Our innovative approach to educational technologies,</li>
  <li style="margin-bottom: 10px;">• Our AI-powered solutions and products,</li>
  <li style="margin-bottom: 10px;">• The potential contributions we can offer to education in Türkiye,</li>
  <li style="margin-bottom: 10px;">• Possible collaborations that can be carried out with the Ministry of National Education,</li>
  <li style="margin-bottom: 10px;">• Our digital learning ecosystem developed for students, teachers, and institutions.</li>
</ul>

As ProgenX, we continue to work to contribute to our country's educational vision and to shape the learning experience of the future.

We extend our sincere thanks to <strong>Mr. M. Bilal Macit</strong> and <strong>Mr. Mustafa Canlı</strong> for their visit and valuable insights.`
      },
      'bett-uk-2026': {
        title: 'We are at BETT UK 2026!',
        excerpt: 'As ProgenX Education and Information Technologies Inc., we are representing our country in London at the Ministry of National Education pavilion.',
        category: 'Event',
        content: `📢 <strong>We are at BETT UK 2026!</strong><br>
As ProgenX Education and Information Technologies Inc., we are representing our country in London at the Ministry of National Education pavilion.

At BETT UK, one of the world's largest education technology fairs, we are proud to showcase the innovative EdTech solutions we have developed as ProgenX on an international stage.

At the fair, we are bringing together our AI-powered educational technologies with educators, public officials, technology leaders, and industry professionals from all around the world.
Starting today, we are presenting both Türkiye's EdTech vision and the technological innovations developed by ProgenX at our stand on an international level.

We look forward to welcoming all our valued visitors to our stand during the three-day fair, which will take place on January 21–22-23.`
      },
      'bett-uk-2026-dayiz': {
        title: 'We are at BETT UK 2026!',
        excerpt: 'As ProgenX Education and Information Technologies Inc., we are representing our country in London at the Ministry of National Education pavilion.',
        category: 'Event',
        content: `📢 <strong>We are at BETT UK 2026!</strong><br>
As ProgenX Education and Information Technologies Inc., we are representing our country in London at the Ministry of National Education pavilion.

At BETT UK, one of the world's largest education technology fairs, we are proud to showcase the innovative EdTech solutions we have developed as ProgenX on an international stage.

At the fair, we are bringing together our AI-powered educational technologies with educators, public officials, technology leaders, and industry professionals from all around the world.
Starting today, we are presenting both Türkiye's EdTech vision and the technological innovations developed by ProgenX at our stand on an international level.

We look forward to welcoming all our valued visitors to our stand during the three-day fair, which will take place on January 21–22-23.`
      },
      'takeoff-istanbul-2025': {
        title: 'We Participated in Take Off İstanbul 2025!',
        excerpt: 'We completed the 2nd day of Take Off İstanbul 2025 with great interest and valuable encounters! Thank you to all local and international participants who visited our stand and closely examined ProgenX solutions.',
        category: 'Event',
        content: `We completed the 2nd day of Take Off İstanbul 2025 with great interest and valuable encounters! 🚀

We thank all local and international participants who visited our stand and closely examined <strong>ProgenX</strong> solutions.

Today we also had the opportunity to attend the presentation of <strong>YEĞİTEK R&D and Ecosystem Department Head Dr. Bilgehan Özbaylanlı</strong>; we thank them for their inspiring sharing.

Within the scope of the event, we conducted an interview with TRT Türk.
If you want to get to know ProgenX more closely, we definitely recommend watching this episode, which will be broadcast on Saturday.

Take Off 2025 has ended — see you at the next event!`
      },
      'take-off-istanbul-2025': {
        title: 'We Participated in Take Off İstanbul 2025!',
        excerpt: 'We completed the 2nd day of Take Off İstanbul 2025 with great interest and valuable encounters! Thank you to all local and international participants who visited our stand and closely examined ProgenX solutions.',
        category: 'Event',
        content: `We completed the 2nd day of Take Off İstanbul 2025 with great interest and valuable encounters! 🚀

We thank all local and international participants who visited our stand and closely examined <strong>ProgenX</strong> solutions.

Today we also had the opportunity to attend the presentation of <strong>YEĞİTEK R&D and Ecosystem Department Head Dr. Bilgehan Özbaylanlı</strong>; we thank them for their inspiring sharing.

Within the scope of the event, we conducted an interview with TRT Türk.
If you want to get to know ProgenX more closely, we definitely recommend watching this episode, which will be broadcast on Saturday.

Take Off 2025 has ended — see you at the next event!`
      },
      'tetz2025-sonuc-raporu': {
        title: 'We Were Featured in TETZ 2025 Results Report!',
        excerpt: 'We were featured in the published results report of Turkey Education Technologies Summit 2025 (TETZ 2025)!',
        category: 'Event',
        content: `📢 <strong>We Share Great Pride!</strong><br>
In the published results report of Turkey Education Technologies Summit 2025 (TETZ 2025), we as ProgenX were also featured! ✨

Being featured in this valuable report at the summit, which was held with the attendance of our President <strong>H.E. Recep Tayyip Erdoğan</strong> and our Minister of National Education <strong>H.E. Yusuf Tekin</strong>, is very valuable for us as one of the actors shaping Turkey's education technologies vision.

Being featured in this valuable report is a reflection of our innovative, inclusive, and sustainable education technology solutions that we have developed for students, teachers, and institutions.

👉 As ProgenX, we will continue to contribute to Turkey's digital education ecosystem and shape the learning experiences of the future.`
      },
      'teknogirisim-rozeti-2025': {
        title: 'ProgenX Earned the Techno-Entrepreneurship Badge!',
        excerpt: 'As ProgenX, we are proud to be one of the first startups to earn the Techno-Entrepreneurship Badge awarded by the Ministry of Industry and Technology of the Republic of Turkey.',
        category: 'Award',
        content: `🏆 We Share with Pride!
As ProgenX, we are proud to be one of the first startups to earn the <strong>Techno-Entrepreneurship Badge</strong> awarded by the <strong>Ministry of Industry and Technology of the Republic of Turkey</strong>! 🎉

This badge aims to increase the visibility of technology and innovation-focused startups, facilitate their access to support mechanisms, and strengthen their position within the ecosystem.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Our Goals with This Badge:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• To advance our solutions and services further</li>
  <li style="margin-bottom: 10px;">• To strengthen our strong position in the technology ecosystem</li>
  <li style="margin-bottom: 10px;">• To reach our innovative projects to wider audiences</li>
</ul>

We thank everyone who contributed. 🤝`
      },
      'aws-activate-2025': {
        title: 'ProgenX Accepted into AWS Activate Program!',
        excerpt: 'As ProgenX, we have been accepted into the AWS Activate program. With this important development, we have gained the opportunity to develop our AI-based projects more strongly.',
        category: 'Program',
        content: `🚀 Big News!
ProgenX has officially joined the <strong>AWS Activate</strong> program! 🎉

With this, we have gained the opportunity to develop our AI-based projects more strongly with the technical infrastructure and support provided by AWS.

💡 We were accepted into the program as a result of our application through <strong>ETKİM</strong>, which is the AWS Activate program provider within the Ministry of National Education Innovation and Education Technologies General Directorate. 
We thank the ETKİM team for their support during the application and acceptance process and AWS for accepting us into the program.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Our Goals:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• To offer innovative solutions in education technologies</li>
  <li style="margin-bottom: 10px;">• To produce next-generation applications</li>
  <li style="margin-bottom: 10px;">• To develop artificial intelligence models</li>
</ul>`
      },
      'tetz-2025': {
        title: 'We Shaped the Future Together at TETZ 2025!',
        excerpt: 'As ProgenX, we are very proud and happy to be part of the Turkey Education Technologies Summit (TETZ 2025) held between June 20-22.',
        category: 'Event',
        content: `This event, which is one of Turkey's largest and most prestigious summits in its field, started with the opening speeches of our President <strong>H.E. Recep Tayyip Erdoğan</strong> and our Minister of National Education <strong>H.E. Yusuf Tekin</strong>. The summit became a platform that made a national impact, addressing digital transformation in education and innovative technologies. We had the opportunity to share our vision in education technologies at the summit we attended under <strong>ETKİM MEB</strong>.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">3 Days of Intense Interest and Interaction</h3>
For three days, participants showed great interest in our stand.
We introduced the AI-powered personalized learning experience offered by <strong>ProgenX</strong> by establishing direct contact with ministry representatives, private school founders, company CEOs, academics, and education entrepreneurs.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">New Users, New Collaborations</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Our visitors had the opportunity to experience our application firsthand.</li>
  <li style="margin-bottom: 10px;">• At the end of the event, <strong>over 500 new users</strong> joined our platform.</li>
  <li style="margin-bottom: 10px;">• We also established contacts for cooperation meetings with many institutions and educational organizations.</li>
  <li style="margin-bottom: 10px;">• Planned meetings were organized with some ministry representatives and concrete steps were taken for the new period.</li>
</ul>

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">We Add Power to Transformation in Education</h3>
The feedback we received in the meetings at our stand, user satisfaction, and increasing download numbers once again proved how strong a response the technology we developed found in the field.
We had meaningful conversations about the project's impact on the public side, the potential of local technologies in education, and the future of digital learning.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">Thanks and Our Future Plans</h3>
We thank all stakeholders who made this great organization possible, especially the <strong>Ministry of National Education</strong> and <strong>ETKİM MEB</strong>.
We are also grateful to all our visitors who met us at the summit, shared their experiences, and contributed to the transformation in education.

<div style="background-color: var(--light-bg); padding: 15px; border-radius: 8px; margin-top: 20px;">
<strong>See you again at future events!</strong>
If you didn't have the opportunity to meet us at TETZ, you can contact us anytime and get to know our platform more closely.
</div>

As ProgenX Academy, we continue to work to offer an innovative, effective, and personalized learning journey to students all over Turkey.`
      },
      'sosyal-sorumluluk-2025': {
        title: 'Supporting Education with Technology: A Social Responsibility Step from ProgenX',
        excerpt: '🌟 ProgenX is touching the future in education!',
        category: 'Social Responsibility',
        content: `Recently, within the scope of HAVELSAN F5 Executive Development Academy, we met with students at Hatay Naim Atakaş Anatolian High School. With this meaningful social responsibility project, as ProgenX, we offered the beta version of our product to students free of charge and answered their questions about technology.

The interaction we had with the students and their excitement both motivated us and strengthened our belief in the power of education and the use of AI in education. We are proud to contribute to their learning journey with our project.

We thank Bürge Kılınç and Berna Şimşek Cansız, who supported us in every way and led us in this process, and the HAVELSAN family.

As ProgenX, we will continue to add value to education with our social and corporate responsibility awareness! 💡`
      },
      'progenx-kurulus': {
        title: 'ProgenX Officially Established!',
        excerpt: 'ProgenX Education and Information Technologies Inc., officially registered in the Turkey Trade Registry Gazette, has set out to offer innovative and sustainable solutions in areas such as education technologies, software development, and AI consulting.',
        category: 'Corporate',
        content: `<strong>ProgenX Education and Information Technologies Inc.</strong>, officially registered in the Turkey Trade Registry Gazette, has set out to offer innovative and sustainable solutions in areas such as education technologies, software development, and AI consulting.

As ProgenX, we act with the mission of contributing to Turkey's digital transformation and enriching learning experiences by using the power of technology in the field of education.`
      },
      'tubitak-mukemmeliyet-muhru': {
        title: 'TÜBİTAK Excellence Seal Award',
        excerpt: 'ProgenX was deemed worthy of an important award such as the TÜBİTAK Excellence Seal with the support of the 1812 - Investment-Based Entrepreneurship Support Program (BiGG Investment) as a result of studies conducted under HAVELSAN consultancy.',
        category: 'Award',
        content: `ProgenX was deemed worthy of an important award such as the <strong>TÜBİTAK Excellence Seal</strong> with the support of the <strong>1812 - Investment-Based Entrepreneurship Support Program (BiGG Investment)</strong> as a result of studies conducted under <strong>HAVELSAN</strong> consultancy.

This award is an important step that officially recognizes ProgenX's success and potential in the field of technology and innovation. This valuable award from TÜBİTAK is an important source of motivation for our company's future projects.

We thank HAVELSAN for their consultancy support.`
      }
    };
    
    const translation = translations[announcement.id];
    if (translation) {
      return {
        ...announcement,
        title: translation.title,
        excerpt: translation.excerpt,
        category: translation.category,
        content: translation.content
      };
    }
    return announcement;
  };

  const translatedAnnouncement = translateAnnouncement(announcement);

  if (!announcement) {
    return (
      <div className="announcement-detail">
        <div className="container" style={{ padding: '100px 20px', textAlign: 'center' }}>
          <h1>Announcement Not Found</h1>
          <p>The announcement you are looking for could not be found.</p>
          <Link to="/en/announcements" className="btn btn-primary">
            Back to Announcements
          </Link>
        </div>
      </div>
    );
  }

  // Find previous and next announcements
  const currentIndex = announcements.findIndex(a => a.slug === slug);
  const previousAnnouncement = currentIndex > 0 ? announcements[currentIndex - 1] : null;
  const nextAnnouncement = currentIndex < announcements.length - 1 ? announcements[currentIndex + 1] : null;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    "headline": translatedAnnouncement.title,
    "datePublished": announcement.date,
    "author": {
      "@type": "Organization",
      "name": "ProgenX Academy"
    },
    "publisher": {
      "@type": "Organization",
      "name": "ProgenX Academy",
      "logo": {
        "@type": "ImageObject",
        "url": "https://progenxacademy.com/logo.png"
      }
    },
    "description": translatedAnnouncement.excerpt,
    "image": announcement.images && announcement.images.length > 0 ? announcement.images[0] : undefined,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://progenxacademy.com/en/announcements/${announcement.slug}`
    }
  };

  const faqData = announcement.faqs || [];
  const translatedFaqs = faqData.map(faq => {
    const translations = {
      'Take Off İstanbul 2025 nedir?': {
        question: 'What is Take Off İstanbul 2025?',
        answer: 'Take Off İstanbul is an international event that brings together entrepreneurs, investors, and technology companies. As ProgenX, we participated in this event and had the opportunity to introduce our solutions.'
      },
      'Take Off İstanbul 2025\'te neler yaptınız?': {
        question: 'What did you do at Take Off İstanbul 2025?',
        answer: 'At the event, we introduced ProgenX solutions at our stand, attended the presentation of YEĞİTEK R&D and Ecosystem Department Head Dr. Bilgehan Özbaylanlı, and conducted an interview with TRT Türk.'
      },
      'TETZ 2025 Sonuç Raporunda ProgenX neden yer aldı?': {
        question: 'Why was ProgenX featured in the TETZ 2025 Results Report?',
        answer: 'ProgenX earned the right to be featured in the TETZ 2025 Results Report thanks to its innovative solutions developed in the field of education technologies and the inclusive education technology platform it offers for students, teachers, and institutions.'
      },
      'TETZ 2025 nedir?': {
        question: 'What is TETZ 2025?',
        answer: 'TETZ (Turkey Education Technologies Summit) 2025 is one of Turkey\'s largest and most prestigious summits in the field of education technologies. This summit, held with the participation of our President and Minister of National Education, is an important platform addressing digital transformation in education.'
      },
      'Teknogirişim Rozeti nedir?': {
        question: 'What is the Techno-Entrepreneurship Badge?',
        answer: 'The Techno-Entrepreneurship Badge is a badge awarded by the Ministry of Industry and Technology of the Republic of Turkey to increase the visibility of technology and innovation-focused startups, facilitate their access to support mechanisms, and strengthen their position within the ecosystem.'
      },
      'ProgenX Teknogirişim Rozeti\'ni nasıl aldı?': {
        question: 'How did ProgenX earn the Techno-Entrepreneurship Badge?',
        answer: 'ProgenX became one of the first startups to earn the Techno-Entrepreneurship Badge thanks to its innovative solutions and achievements in the field of education technologies and artificial intelligence.'
      },
      'AWS Activate programı nedir?': {
        question: 'What is the AWS Activate program?',
        answer: 'AWS Activate is a program that provides AWS cloud infrastructure, technical support, and educational resources to startups. ProgenX was accepted into this program by applying through MEB ETKİM.'
      },
      'AWS Activate programı ProgenX\'e ne sağlıyor?': {
        question: 'What does the AWS Activate program provide to ProgenX?',
        answer: 'Thanks to the AWS Activate program, ProgenX has gained the opportunity to develop its AI-based projects more strongly, offer innovative solutions in education technologies, and produce next-generation applications.'
      },
      'BETT UK 2026 nedir?': {
        question: 'What is BETT UK 2026?',
        answer: 'BETT UK is one of the world\'s largest education technology fairs. As ProgenX, we are representing our country at this fair in the Ministry of National Education pavilion in London and sharing our innovative EdTech solutions on an international stage.'
      },
      'BETT UK 2026\'da neler yapıyorsunuz?': {
        question: 'What are you doing at BETT UK 2026?',
        answer: 'At the fair, we are bringing together our AI-powered educational technologies with educators, public officials, technology leaders, and industry professionals from all around the world. At our stand, we are presenting both Türkiye\'s EdTech vision and the technological innovations developed by ProgenX at an international level.'
      },
      'BETT UK\'te hangi yetkililer ProgenX standını ziyaret etti?': {
        question: 'Which officials visited the ProgenX stand at BETT UK?',
        answer: 'At BETT UK, Deputy Minister of the Ministry of National Education, Mr. M. Bilal Macit, and Director General of Innovation and Educational Technologies, Mr. Mustafa Canlı, visited the ProgenX stand.'
      },
      'Ziyaret kapsamında neler değerlendirildi?': {
        question: 'What was evaluated during the visit?',
        answer: 'During the visit, our innovative approach to educational technologies, our AI-powered solutions and products, the potential contributions we can offer to education in Türkiye, possible collaborations that can be carried out with the Ministry of National Education, and our digital learning ecosystem developed for students, teachers, and institutions were evaluated.'
      },
      'ETKİM Ekosistem Buluşması nedir?': {
        question: 'What is the ETKİM Ecosystem Meeting?',
        answer: 'The "Educational Technologies Ecosystem Meeting" held hosted by ETKİM (Educational Technologies Incubation and Innovation Center) is an important event that brings together stakeholders in the field of educational technologies.'
      },
      'Bakan ziyareti kapsamında neler değerlendirildi?': {
        question: 'What was evaluated during the Minister\'s visit?',
        answer: 'During the event, a comprehensive evaluation was made with our Minister about ProgenX\'s work, our innovative approach to educational technologies, our AI-powered solutions, our digital learning ecosystem, and our student-teacher-focused vision.'
      }
    };
    
    const translation = translations[faq.question];
    return translation ? { question: translation.question, answer: translation.answer } : faq;
  });

  const faqStructuredData = translatedFaqs.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": translatedFaqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  } : null;

  return (
    <div className="announcement-detail">
      <Helmet>
        <title>{translatedAnnouncement.title} | ProgenX Announcements</title>
        <meta name="description" content={translatedAnnouncement.excerpt} />
        <meta name="keywords" content={`progenx, ${announcement.tags ? announcement.tags.join(', ') : ''}, ${translatedAnnouncement.category}, announcements`} />
        <meta property="og:title" content={translatedAnnouncement.title} />
        <meta property="og:description" content={translatedAnnouncement.excerpt} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`https://progenxacademy.com/en/announcements/${announcement.slug}`} />
        {announcement.images && announcement.images.length > 0 && (
          <meta property="og:image" content={`https://progenxacademy.com${announcement.images[0]}`} />
        )}
        <meta property="article:published_time" content={announcement.date} />
        <meta property="article:author" content="ProgenX Academy" />
        <meta property="article:section" content={translatedAnnouncement.category} />
        <link rel="canonical" href={`https://progenxacademy.com/en/announcements/${announcement.slug}`} />
        <link rel="alternate" hreflang="tr" href={`https://progenxacademy.com/duyurular/${announcement.slug}`} />
        <link rel="alternate" hreflang="en" href={`https://progenxacademy.com/en/announcements/${announcement.slug}`} />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
        {faqStructuredData && (
          <script type="application/ld+json">
            {JSON.stringify(faqStructuredData)}
          </script>
        )}
      </Helmet>
      
      <Hero 
        title={translatedAnnouncement.title} 
        backgroundImage={duyurularHeroImage}
      />
      
      <section className="announcement-detail-content">
        <div className="container">
          <Link to="/en/announcements" className="back-link">
            <FontAwesomeIcon icon={faArrowLeft} />
            Back to All Announcements
          </Link>

          <article className="announcement-article">
            <div className="announcement-meta">
              <span className="announcement-category">
                <FontAwesomeIcon icon={faTag} /> {translatedAnnouncement.category || announcement.category}
              </span>
              <span className="announcement-date">
                <FontAwesomeIcon icon={faCalendarAlt} /> {announcement.date}
              </span>
            </div>

            {announcement.images && announcement.images.length > 0 && (
              <div className="announcement-gallery">
                <ImageGallery images={announcement.images} />
              </div>
            )}

            <div 
              className="announcement-content"
              dangerouslySetInnerHTML={{ __html: translatedAnnouncement.content || announcement.content }} 
            />

            {announcement.links && announcement.links.length > 0 && (
              <div className="announcement-links">
                <h3>Related Links</h3>
                <ul>
                  {announcement.links
                    .filter(link => {
                      // Show links with (English) or links without language indicator
                      return link.text.includes('(English)') || (!link.text.includes('(Türkçe)') && !link.text.includes('(English)'));
                    })
                    .map((link, index) => {
                      // Remove language indicator and translate
                      const linkTranslations = {
                        'LinkedIn\'de paylaşımı görüntüle': 'View post on LinkedIn',
                        'Instagram\'da paylaşımı görüntüle': 'View post on Instagram',
                        'Instagram\'da görüntüle': 'View on Instagram',
                        'LinkedIn\'de görüntüle': 'View on LinkedIn',
                        'ETKİM MEB LinkedIn Paylaşımı': 'ETKİM MEB LinkedIn Post',
                        'Yeni Şafak Haberi': 'Yeni Şafak News',
                        'Hürriyet Haberi': 'Hürriyet News',
                        'Bursa MEB Haberi': 'Bursa MEB News'
                      };
                      const baseText = link.text.replace(' (English)', '').replace(' (Türkçe)', '');
                      const linkText = linkTranslations[baseText] || baseText;
                      return (
                        <li key={index}>
                          <a href={link.url} target="_blank" rel="noopener noreferrer">
                            {linkText}
                          </a>
                        </li>
                      );
                    })}
                </ul>
              </div>
            )}

            {announcement.tags && announcement.tags.length > 0 && (
              <div className="announcement-tags">
                {announcement.tags.map((tag, index) => (
                  <span key={index} className="tag">#{tag}</span>
                ))}
              </div>
            )}

            {translatedFaqs.length > 0 && (
              <section className="announcement-faq">
                <h2>Frequently Asked Questions</h2>
                {translatedFaqs.map((faq, index) => (
                  <div key={index} className="faq-item">
                    <h3 className="faq-question">{faq.question}</h3>
                    <p className="faq-answer">{faq.answer}</p>
                  </div>
                ))}
              </section>
            )}
          </article>

          <div className="announcement-navigation">
            {previousAnnouncement && (() => {
              const prevTranslated = translateAnnouncement(previousAnnouncement);
              return (
                <Link to={`/en/announcements/${previousAnnouncement.slug}`} className="nav-link prev">
                  <FontAwesomeIcon icon={faArrowLeft} />
                  <div>
                    <span className="nav-label">Previous</span>
                    <span className="nav-title">{prevTranslated.title}</span>
                  </div>
                </Link>
              );
            })()}
            {nextAnnouncement && (() => {
              const nextTranslated = translateAnnouncement(nextAnnouncement);
              return (
                <Link to={`/en/announcements/${nextAnnouncement.slug}`} className="nav-link next">
                  <div>
                    <span className="nav-label">Next</span>
                    <span className="nav-title">{nextTranslated.title}</span>
                  </div>
                  <FontAwesomeIcon icon={faArrowLeft} style={{ transform: 'rotate(180deg)' }} />
                </Link>
              );
            })()}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AnnouncementDetailEN;
